import {ApolloLink} from "apollo-link"

// omit typename on update https://github.com/apollographql/apollo-client/issues/1564
const omitTypename = (key: string, value: any) => (key === "__typename" ? undefined : value)

export const omitTypenameLink = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename)
  }
  return forward(operation)
})
